(function () {
    "use strict";

    // @ngInject
    function WorkspaceWorkflowInstanceControllerCtor($scope, $injector, $modalInstance, CompaniesManager, AppStates, $state, $translate,
                                                     WorkflowManager, workspace, workflowId, moment, _, WorkflowService, AnalyticsService,
                                                     PopupMessageService, ModalService, UiPersistenceService, $q, $timeout, TemplatesManager, UsersManager, WebsocketHelperService) {
        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'WorkspaceWorkflowInstanceController';

        var self = this;
        this.$translate = $translate;
        this.modalInstance = $modalInstance;
        this.AppStates = AppStates;
        this.$state = $state;
        this.CompaniesManager = CompaniesManager;
        this.moment = moment;
        this.AnalyticsService = AnalyticsService;
        this._ = _;
        this.WorkflowService = WorkflowService;
        this.PopupMessageService = PopupMessageService;
        this.UiPersistenceService = UiPersistenceService;
        this.$q = $q;
        this.$timeout = $timeout;

        this.company = CompaniesManager.getCurrCompany();
        this.WorkflowManager = WorkflowManager;
        this.ModalService = ModalService;
        this.TemplatesManager = TemplatesManager;
        this.WebsocketHelperService = WebsocketHelperService;

        this.user = UsersManager.getCurrUser();
        this.workspace = workspace;
        this.workflowId = workflowId;

        this.approvedStep = false;

        this.workflowStepsCollection = [];
        this.stepApproveIndicator = false;
        this.loadWorkflowIndicator = true;
        this.changedToApproved = [];
        this.workflowStepIsDecline = [];

        this.fetchWorkflow();

        this.WebsocketHelperService.registerToRoom(this.workspace._id + ".refresh_workflow_full_view", this.fetchWorkflow.bind(this));

        // clean up
        $scope.$on('$destroy', function () {
            this.WebsocketHelperService.unregisterFromRoom(this.workspace._id + ".refresh_workflow_full_view");
        }.bind(this));
    }

    Controllers.WorkspaceWorkflowInstanceController = Class(Controllers.BaseController, {
        constructor: WorkspaceWorkflowInstanceControllerCtor,

        setWorkflowStepModel: function setWorkflowStepModel(stepModel) {
            this.workflowStepsCollection = stepModel.workflow_steps;
        },

        formatDate: function formatDate(date) {
            this.dateTrigger = '';
            if (date && this.moment(date, 'YYYY-MM-DD').isValid()) {
                this.dateTrigger = this.moment(date, 'YYYY-MM-DD').calendar(null, {
                    lastDay: '[Yesterday]',
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    lastWeek: 'LL',
                    nextWeek: 'LL',
                    sameElse: 'LL'
                });
            }
            return this.dateTrigger;
        },

        getTriggerTypeText: function (stepTrigger) {
            return this.$translate.instant(this._.findWhere(this.WorkflowService.workflowTriggersEnum, {key: stepTrigger.trigger_type}).textTranslationKey);
        },

        getApprovalTypeText: function (stepApprovalType) {
            return this.WorkflowService.getApprovalTypeText(stepApprovalType);
        },

        triggerDateFutureOrPast: function triggerDateFutureOrPast(dateTriggerStep) {
            this.isTriggerDate = '';
            if (dateTriggerStep && this.moment(dateTriggerStep, 'YYYY-MM-DD').isValid()) {
                var date = this.moment(dateTriggerStep, 'YYYY-MM-DD').calendar(null, {
                    lastDay: '[Yesterday]',
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    lastWeek: 'LL',
                    nextWeek: 'LL',
                    sameElse: 'LL'
                });
                if (date === "Today") {
                    this.isTriggerDate = "today";
                    return this.isTriggerDate;
                }
                if (this.moment(dateTriggerStep) > this.moment()) {
                    this.isTriggerDate = "future";
                    return this.isTriggerDate;
                }

                if (this.moment(dateTriggerStep) < this.moment()) {
                    this.isTriggerDate = "overdue";
                    return this.isTriggerDate;
                }
            }

        },

        setSkipWorkFlowStep: function setSkipWorkFlowStep(stepId) {
            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'WORKFLOW.ALERTS._DELETING_CURRENT_OR_FUTURE_APPROVAL_',
                function clickedYeah() {
                    this.workflowStepIsDecline[stepId] = true;
                    this.WorkflowManager.changeWorkflowStepState(this.workspace._id, stepId, 'declined')
                        .then(function success() {
                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.workflow_mark_as_declined, {origin: "workspace_full_view"});
                        }.bind(this));
                }.bind(this),
                function clickedNay() {
                }.bind(this));
        },

        markAsApproved: function markAsApproved(step) {
            var uiPersistenceData = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.workflowApprovalDependedStep);
            if (step.approval_status === 'required' && step.has_depended_step && (!uiPersistenceData || (uiPersistenceData && !uiPersistenceData.dontShow))) {
                this.PopupMessageService.showConfirmWithDontShowAgain(this.PopupMessageService.severityTypes.warning,
                    'WORKFLOW.WORKFLOW_STEPS_EDITOR.DO_NOT_SHOW_AGAIN._MSG_COPY_',
                    function clickedYeah() {
                        return this.approveStep(step);
                    }.bind(this),
                    function clickedNay() {
                    }.bind(this), null, null, this.UiPersistenceService.keys.workflowApprovalDependedStep);
            }
            else {
                return this.approveStep(step);
            }
        },

        approveStep: function approveStep(step) {
            this.stepApproveIndicator = true;
            this.changedToApproved[step._id] = true;

            this.WorkflowManager.changeWorkflowStepState(this.workspace._id, step._id, 'approved')
                .then(function success() {
                    this.stepApproveIndicator = false;
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.workflow_mark_step_as_approved, {origin: "workspace_full_view"});
                }.bind(this));
        },

        markAsApprovedWithEmail: function markAsApproved(stepId, subject, body, attachedFiles) {
            this.stepApproveIndicator = true;
            this.changedToApproved[stepId] = true;

            return this.WorkflowManager.changeWorkflowStepState(this.workspace._id, stepId, 'approved', subject, body, attachedFiles)
                .then(function success() {
                    this.stepApproveIndicator = false;
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.workflow_mark_step_email_as_approved, {origin: "workspace_full_view"});
                }.bind(this));
        },

        openPreviewEmail: function openPreviewEmail(step) {
            var templateId = step.workflow_step_action.email_template_id;
            this.TemplatesManager.getEmail(this.company, this.user, templateId).then(function success() {
                var currentTemplate = this._.find(this.company.vendor_emails, function (template) {
                    return template._id === templateId;
                });

                this.subject = currentTemplate.subject;
                this.body = currentTemplate.html_body;

                var usersListForEmail = this.workspace.members.filter(function (user) {
                    return (!!user.email && user._id !== this.company.owner._id && !user.isMyTeamMember());
                }.bind(this));

                var options  = {
                    users: usersListForEmail,
                    subject: currentTemplate.subject,
                    body: currentTemplate.html_body,
                    generalFiles: currentTemplate.file_attachments,
                    imageFiles: currentTemplate.image_attachments,
                    senderFunction: function sendFunction(user, subject, body, isLast, params, attachedFiles) {
                        var uiPersistenceData = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.workflowApprovalDependedStep);
                        if (step.approval_status === 'required' && step.has_depended_step && (!uiPersistenceData || (uiPersistenceData && !uiPersistenceData.dontShow))) {
                            return this.PopupMessageService.showConfirmWithDontShowAgainPromise(this.PopupMessageService.severityTypes.warning,
                                'WORKFLOW.WORKFLOW_STEPS_EDITOR.DO_NOT_SHOW_AGAIN._MSG_COPY_', null, null, null, this.UiPersistenceService.keys.workflowApprovalDependedStep).then(
                                function confirmCallback() {
                                    return this.markAsApprovedWithEmail(step._id, subject, body, attachedFiles);
                                }.bind(this),
                                function dismissCallback() {
                                    return this.$q.reject("closeEmailEditor");
                                }.bind(this));
                        }
                        else {
                            return this.markAsApprovedWithEmail(step._id, subject, body, attachedFiles);
                        }
                    }.bind(this),
                    config: this.emailEditorConfig(),
                    showScheduleOption: false
                };

                this.ModalService.openEmailEditorModal(options);
            }.bind(this));
        },

        cancelModal: function cancelModal() {
            this.modalInstance.dismiss();
        },

        getStepAttachmentTitle: function getStepAttachmentTitle(count) {
            var stringToTranslate = 'WORKFLOW.TOOLTIPS._WORKFLOW_FILE_ATTACHED_';
            if (count > 1) {
                stringToTranslate = 'WORKFLOW.TOOLTIPS._WORKFLOW_FILE_ATTACHED_PLURAL_';
            }
            return this.$translate.instant(stringToTranslate);
        },

        fetchWorkflow: function fetchWorkflow() {
            this.loadWorkflowIndicator = true;
            this.WorkflowManager.getWorkflowInstance(this.workspace._id).then(function success(workflow) {
                if (workflow) {
                    this.workflowInstance = workflow;
                    this.setWorkflowStepModel(this.workflowInstance);
                }
            }.bind(this)).finally(function() {
                this.loadWorkflowIndicator = false;
            }.bind(this));
        },

        emailEditorConfig: function emailEditorConfig() {
            var config = {};
            config.ckeditor = {
                includeToolbarItems: ['AddClientName', 'AddEmailSignature', 'addFileAttachment'],
                height: "300px",
            };
            if (this.user.calendly_url) {
                config.ckeditor.includeToolbarItems.push('addCalendlyLink');
            }
            config.dontLoopOverRecipients = true;
            config.sendButtonText = 'WORKFLOW.APPROVAL._APPROVE_AND_SEND_NOW_';
            config.cancelButtonText = 'WORKFLOW.APPROVAL._GO_BACK_';
            config.editorType = "workflow email";

            return config;
        }
    });
}());
